import { useTranslation } from 'react-i18next'

import {
  PrescriptionWorkflowName,
  PrescriptionWorkflowType,
} from '~/constants/PrescriptionWorkflow'

import WorkflowSectionItem from './WorkflowSectionItem'

export interface OutsidePharmacyWorkflowProps {
  disabled: boolean
  showDisabledTooltip?: boolean
}

const workflow = PrescriptionWorkflowType.OUTSIDE_PHARMACY
const label = PrescriptionWorkflowName[workflow]

const OutsidePharmacyWorkflow = ({
  disabled,
  showDisabledTooltip = true,
}: OutsidePharmacyWorkflowProps) => {
  const { t } = useTranslation('Tooltips')

  const disabledTooltip = t('Tooltips:WORKFLOW_TOOLTIP')

  return (
    <WorkflowSectionItem
      disabled={disabled}
      disabledTooltip={disabled && showDisabledTooltip ? disabledTooltip : ''}
      label={label}
      workflow={workflow}
    />
  )
}

export default OutsidePharmacyWorkflow
